import "./index.scss";
import React, { useState, useEffect } from "react";
import axios from "../../services/axios";

export default function InspectionDetailsModal({
  inspectionPerson,
  label,
  toggleModal,
  handleChange,
  getInspectors,
  getBrokers,
}) {
  const [formData, setFormData] = useState({
    name: "",
    company: "",
    email: "",
    phone: "",
  });

  // Update form data when inspectionPerson changes (edit mode) or clear when it's null (add mode)
  useEffect(() => {
    if (inspectionPerson) {
      setFormData({
        name: inspectionPerson.name || "",
        company: inspectionPerson.company || "",
        email: inspectionPerson.email || "",
        phone: inspectionPerson.phone || "",
      });
    } else {
      // Clear form for add new mode
      setFormData({
        name: "",
        company: "",
        email: "",
        phone: "",
      });
    }
  }, [inspectionPerson]);

  const handleInputChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  const createInspector = async (data) => {
    try {
      const response = await axios.post("/domoreport/uploader/inspector", data);
      if (response.data.inspector_ref_id) {
        const inspector = {
          id: response.data.inspector_ref_id,
          name: data.inspector_person_name,
          company: data.inspection_company,
        };
        handleChange("inspection_company", inspector);
        getInspectors();
      }
    } catch (error) {
      console.error("Error creating inspector:", error);
    }
  };

  const updateInspector = async (data, id) => {
    try {
      const response = await axios.put(
        `/domoreport/uploader/inspector/${id}`,
        data
      );
      if (response.data.success) {
        const inspector = {
          id: id,
          name: data.inspector_person_name,
          company: data.inspection_company,
          email: data.inspection_email,
          phone: data.inspection_phone,
        };
        handleChange("inspection_company", inspector);
        getInspectors();
      }
    } catch (error) {
      console.error("Error updating inspector:", error);
    }
  };

  const createBroker = async (data) => {
    try {
      const response = await axios.post("/domoreport/uploader/broker", data);
      if (response.data.broker_ref_id) {
        const broker = {
          id: response.data.broker_ref_id,
          name: data.broker_person_name,
          company: data.brokerage,
        };
        handleChange("agent", broker);
        getBrokers();
      }
    } catch (error) {
      console.error("Error creating broker:", error);
    }
  };

  const updateBroker = async (data, id) => {
    try {
      const response = await axios.put(
        `/domoreport/uploader/broker/${id}`,
        data
      );
      if (response.data.success) {
        const broker = {
          id: id,
          name: data.broker_person_name,
          company: data.brokerage,
          email: data.brokerage_email,
          phone: data.brokerage_phone,
        };
        handleChange("agent", broker);
        getBrokers();
      }
    } catch (error) {
      console.error("Error updating broker:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { name, company, email, phone } = formData;

    if (label === "inspection_company") {
      const data = {
        inspector_person_name: name,
        inspection_company: company,
        inspection_email: email,
        inspection_phone: phone,
      };

      if (inspectionPerson) {
        await updateInspector(data, inspectionPerson.id);
      } else {
        await createInspector(data);
      }
    } else if (label === "agent") {
      const data = {
        broker_person_name: name,
        brokerage: company,
        brokerage_email: email,
        brokerage_phone: phone,
      };

      if (inspectionPerson) {
        await updateBroker(data, inspectionPerson.id);
      } else {
        await createBroker(data);
      }
    }

    toggleModal(e, null);
  };

  const { name, company, email, phone } = formData;
  let displayLabel = "";

  if (label === "inspection_company") {
    displayLabel = "Inspector";
  } else if (label === "agent") {
    displayLabel = "Agent";
  }

  return (
    <div className="md-diy-inspector-modal">
      <div className="md-diy-sidebar-form">
        <h4>
          {inspectionPerson ? "Edit" : "Add New"} {displayLabel}
        </h4>
        <label>Name</label>
        <div className="md-diy-input-wrapper">
          <img
            src="/assets/icons/Name.svg"
            className="md-diy-input-icon"
            alt=""
          />
          <input
            type="text"
            placeholder="Name"
            onChange={(e) => handleInputChange("name", e.target.value)}
            value={name || ""}
          />
        </div>

        <label>Company</label>
        <div className="md-diy-input-wrapper">
          <img
            src="/assets/icons/Company.svg"
            className="md-diy-input-icon"
            alt=""
          />
          <input
            type="text"
            placeholder="Company Name"
            onChange={(e) => handleInputChange("company", e.target.value)}
            value={company || ""}
          />
        </div>

        <label>Email</label>
        <div className="md-diy-input-wrapper">
          <img
            src="/assets/icons/Email.svg"
            className="md-diy-input-icon"
            alt=""
          />
          <input
            type="text"
            placeholder="Email Address"
            onChange={(e) => handleInputChange("email", e.target.value)}
            value={email || ""}
          />
        </div>

        <label>Phone</label>
        <div className="md-diy-input-wrapper">
          <img
            src="/assets/icons/Phone.svg"
            className="md-diy-input-icon"
            alt=""
          />
          <input
            type="text"
            placeholder="Phone Number"
            onChange={(e) => handleInputChange("phone", e.target.value)}
            value={phone || ""}
          />
        </div>
      </div>

      <div className="md-diy-modal-footer">
        <button
          type="button"
          className="btn btn-cancel"
          onClick={(e) => toggleModal(e, null)}
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleSubmit}
        >
          Save
        </button>
      </div>
    </div>
  );
}
